import LanguageAdder from "@/components/LanguageAdder";

const LanguagesPage = () => {
    return (
        <div>
            <h1 className="text-3xl font-bold text-primary">Nyelvek</h1>
            <p className="mt-4 text-foreground/80 mb-8">Itt kezelheted az alkalmazásban elérhető nyelveket.</p>
            <LanguageAdder />
        </div>
    );
};

export default LanguagesPage;
